module.exports = __webpack_public_path__ + "img/volume-max.85e91b6b.svg";